import { render, staticRenderFns } from "./monitorMain.vue?vue&type=template&id=0904a515&"
import script from "./monitorMain.vue?vue&type=script&lang=js&"
export * from "./monitorMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports